"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SentryError = void 0;
const Sentry = __importStar(require("@sentry/browser"));
const is_defined_1 = require("../is-defined");
// https://medium.com/@Nelsonalfonso/understanding-custom-errors-in-typescript-a-complete-guide-f47a1df9354c
class SentryError extends Error {
    constructor(message, config) {
        super(message);
        this.name = 'SentryError';
        Object.setPrototypeOf(this, SentryError.prototype);
        // reported as a copy with name/message swapped: Sentry titles by `name`
        const reported = new Error('SentryError');
        reported.name = message;
        reported.stack = this.stack;
        Sentry.captureException(reported, (scope) => {
            scope.setTag('scope', 'SentryError');
            const _tags = config?.tags;
            if ((0, is_defined_1.isValue)(_tags)) {
                scope.setTags(_tags);
            }
            const _extras = config?.extras;
            if ((0, is_defined_1.isValue)(_extras)) {
                scope.setContext('extra', _extras);
            }
            return scope;
        });
    }
}
exports.SentryError = SentryError;
